<header obg-app-m-header-container toolbarHidden navigationHidden static [titleText]="title$ | async"></header>
<div class="obg-m-core-slim-layout-content">
	<router-outlet></router-outlet>
</div>
<obg-footer-container></obg-footer-container>
